import React, { useState, useEffect } from 'react';
import './Casos.css';

import icono_gif from '../../assets/img/casos/icono-gif.png';
import icono_video from '../../assets/img/casos/icono-video.png';
import icono_imagenes from '../../assets/img/casos/icono-imagenes.png';
import boton_flecha_siguiente from '../../assets/img/boton_flecha_siguiente.png';

import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import ReactMarkdown from 'react-markdown';
import casos from '../Home/Casos.json';
import { useParams, Redirect } from 'react-router-dom';

import $ from 'jquery';
import Footer from '../Footer';
import UsePageMetadata from '../../hooks/UsePageMetadata';

const ASSETS_URL = './assets/proyectos';

const Caso = ({ guardarWhite }) => {
  const { name, number } = useParams();
  const [redirectTo, setRedirectTo] = useState(null);
  const [caso, setCaso] = useState(null);

  const nextCaso = parseInt(number) < casos.length ? casos[parseInt(number)] : null;

  useEffect(() => {
    window.scrollTo(0, 0);
    setCaso(casos.find((c) => c.nombre === name) ?? null);

    document.querySelector('.fondo_blanco').classList.remove('fondo_blanco_animation');
    document.querySelector('.fondo_blanco_top').classList.remove('fondo_blanco_animation_top');
  }, [name]);

  useEffect(() => {
    if (!caso) return;

    guardarWhite(caso.white_logo ?? false);

    document.querySelector('.number').classList.remove('rotate_number');
    document.querySelector('.header_caso').classList.add('header_caso_animation');
    document.querySelector('.header_content').classList.add('fadeIn_1');
    document.querySelector('.multimedia_contenedor').classList.add('fadeIn_2');
    document.querySelector('.body_caso').classList.add('fadeIn_2');

    const handleScroll = () => {
      const scroll = $(window).scrollTop();
      const objectPosition = $('.scroll_animacion').offset().top - 250;
      const multimediaPosition = $('.scroll_animacion_2').offset().top;

      if (scroll >= objectPosition && scroll <= multimediaPosition) {
        $('.number').addClass('rotate_number');
      } else {
        $('.number').removeClass('rotate_number');
      }
    };

    $(window).on('scroll', handleScroll);
    return () => $(window).off('scroll', handleScroll);
  }, [caso, guardarWhite]);

  const animation = () => {
    document.querySelector('.fondo_blanco').classList.add('fondo_blanco_animation');
    document.querySelector('.fondo_blanco_top').classList.add('fondo_blanco_animation_top');

    setTimeout(() => {
      window.scrollTo(0, 0);
      document.querySelector('.header_caso').classList.remove('header_caso_animation');
      document.querySelector('.header_content').classList.remove('fadeIn_1');
      document.querySelector('.multimedia_contenedor').classList.remove('fadeIn_2');
      document.querySelector('.body_caso').classList.remove('fadeIn_2');
    }, 2400);
  };

  const handleNextCase = (destination) => {
    document.querySelector('.next_caso img').classList.add('flecha_caso_animacion');
    setTimeout(() => {
      if (destination === 'nosotros') {
        setRedirectTo('nosotros');
      } else {
        window.location.href = `https://indio.guru/#/proyecto/${nextCaso.nombre}/${parseInt(number) + 1}`;
      }
    }, 2600);
  };

  UsePageMetadata(caso?.title_seo ?? '');

  if (redirectTo === 'nosotros') return <Redirect to='/nosotros' />;

  return (
    <section className='caso_modal'>
      {caso && (
      <div>
        <div className='contenedor_caso' id={`${caso.nombre}_caso`}>
          <div
            className='header_caso'
            style={{
              background: `url('${ASSETS_URL}/${caso.banner.img}')`,
              backgroundSize: 'cover',
              backgroundPosition: caso.banner.position,
            }}
          />

          <div className='contenedor_fadeOut'>
            <div className='header_content'>
              <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]}>
                {caso.title}
              </ReactMarkdown>
              <p>{caso.description}</p>
            </div>

            <div className='clearfix' />

            <div className='body_caso'>
              <div className='scroll_animacion' />

              <div className='content_body'>
                <p className='lateral'>—Caso</p>
                <p className='number'>{number}</p>

                <div className='separador_content_body'>
                  <div className='center'>
                    <b>Brief</b>
                    <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]}>
                      {caso.brief}
                    </ReactMarkdown>
                  </div>
                </div>

                {caso.constribucion && (
                  <div className='separador_content_body'>
                    <div className='center'>
                      <b>Nuestra <span>contribución</span></b>
                      <div>
                        <ul className='font_bold'>
                          <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]}>
                            {caso.constribucion}
                          </ReactMarkdown>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className='scroll_animacion_2' />

            <div className='multimedia_contenedor'>
              <div className='separador_multimedia'>
                <div className='imagenes'>
                  {caso.galeria.map((galeria, i) => (
                    <React.Fragment key={i}>
                      {galeria.tipo === 'normal' ? (
                        <>
                          {galeria.imagenes.map((img, j) => (
                            <img key={j} style={{ width: img.width }} src={`${ASSETS_URL}/${img.img}`} alt='caso' loading='lazy' />
                          ))}
                          {galeria.videos.map((video, j) => (
                            <video key={j} muted playsInline autoPlay loop style={{ width: video.width }}>
                              <source src={`${ASSETS_URL}/${video.img}`} type='video/mp4' />
                            </video>
                          ))}
                        </>
                      ) : (
                        <div className='all_gallery_flex'>
                          {galeria.imagenes.map((img, j) => (
                            <img key={j} src={`${ASSETS_URL}/${img.img}`} alt='caso' loading='lazy' />
                          ))}
                          {galeria.videos.map((video, j) => (
                            <video key={j} muted playsInline autoPlay loop>
                              <source src={`${ASSETS_URL}/${video.img}`} type='video/mp4' />
                            </video>
                          ))}
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                </div>

                <div className='icons_multimedia'>
                  <div className='icons'>
                    <div className='icon'><img src={icono_gif} alt='icono' /></div>
                    <div className='icon'><img src={icono_video} alt='icono' /></div>
                    <div className='icon'><img src={icono_imagenes} alt='icono' /></div>
                  </div>
                  <div className='galeria'>
                    <span className='lateral'>multimedia </span>
                    <span className='lateral'>Galería </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className='next_caso'
          onClick={() => {
            handleNextCase(nextCaso ? 'next' : 'nosotros');
            animation();
          }}
        >
          <img src={boton_flecha_siguiente} alt='siguiente' />
          <p>{nextCaso ? 'Ver siguiente caso' : 'Ir a Nosotros'}</p>
        </div>
      </div>
      )}

      <div className='fondo_blanco' />
      <div className='fondo_blanco_top' />
      <Footer />
    </section>
  );
};

export default Caso;
